import {
    SYSTEM_ID_FOR_NEW,
    SYSTEM_TYPE_EXISTING,
} from '../../../../Constants/gen1Constants';

export const GEN1_APPLICATION_TYPE_CHANGE_CONFIRM_MESSAGE =
    'Changing the application type will clear Gen1 Trunking Information (repeater operations, repeater details, and SO# Search data). Customer Information will be kept. Do you want to continue?';

export const GEN1_SYSTEM_TYPE_CHANGE_CONFIRM_MESSAGE =
    'Changing the System Type will clear Gen1 Trunking Information (repeater operations, repeater details, and SO# Search data). Customer Information will be kept. Do you want to continue?';

/** 再 Search 時の confirm（{orderNumber} 差し込み） */
export function buildOrderSearchConfirmMessage(orderNumber) {
    const trimmed = String(orderNumber ?? '').trim();
    return (
        `Running Order Search for Sales Order Number (SO#) ${trimmed} may reset Repeater Details rows from this SO# that no longer match the search results. ` +
        'Rows from other SO#s and manually added rows are not changed. ' +
        'If rows are reset, select and register again from the search results.'
    );
}

/** Search 0 件 */
export const ORDER_SEARCH_NO_RESULTS_MESSAGE =
    'No repeater serials were found for this Sales Order Number (SO#). Please verify the SO# and search again, or enter details manually (Add Row).';

/** Search API 失敗 */
export const ORDER_SEARCH_API_ERROR_MESSAGE =
    'An error occurred while searching Sales Order Number (SO#). Please try again.';

/** 候補モーダル固定注意 */
export const ORDER_SEARCH_MODAL_NOTICE_MESSAGE =
    'Already-submitted Serial # will not be shown in the search results.';

const TRUNKING_LINE_RESET_KEYS = [
    'BaseModel',
    'SerialNumber',
    'OrderNumber',
    'ExchangeSystemId',
];

/**
 * System Type 変更時に Trunking 入力がありリセット確認が必要か。
 * @param {Object} state - Gen1Application の state
 * @returns {boolean}
 */
export function hasTrunkingInformationToReset(state) {
    const order = state.gen1Order ?? {};
    const item = order.Gen1TrunkingOrderItem ?? {};
    const lines = order.Gen1TrunkingOrderRepeaterSerials ?? [];

    if ((state.orderNumber ?? '').trim()) {
        return true;
    }
    if ((state.otherSystemId ?? '').trim()) {
        return true;
    }

    const qtys = [
        Number(item.RepeaterQty) || 0,
        Number(item.MultiSiteNetworkingQty) || 0,
        Number(item.ExchangeRepeaterPairQty) || 0,
        Number(item.RemoveRepeaterQty) || 0,
    ];
    if (qtys.some((n) => n > 0)) {
        return true;
    }

    if (
        lines.some((l) =>
            TRUNKING_LINE_RESET_KEYS.some(
                (k) => (l?.[k] ?? '').toString().trim() !== ''
            )
        )
    ) {
        return true;
    }

    const sysId = (order.SystemId ?? '').toString().trim();
    if (
        order.SystemType === SYSTEM_TYPE_EXISTING &&
        sysId &&
        sysId !== SYSTEM_ID_FOR_NEW
    ) {
        return true;
    }

    return false;
}

/**
 * 申請種別が購入済みか（boolean 正規化）。
 * @param {boolean|undefined|null} value
 * @returns {boolean}
 */
export function isPurchasedRepeatersFlag(value) {
    return value === true;
}

/**
 * 種別変更で現種別と同じか。
 * @param {boolean|undefined|null} current
 * @param {boolean} next
 * @returns {boolean}
 */
export function isSameApplicationType(current, next) {
    return isPurchasedRepeatersFlag(current) === isPurchasedRepeatersFlag(next);
}
